import React from 'react';

import styles from '../Signup.module.css';

function LineIcon({ fill }: { fill?: boolean }) {
  return (
    <svg
      className={styles.signupProgressLine}
      width="95"
      height="2"
      viewBox="0 0 95 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="95"
        height="2"
        rx="1"
        fill={fill ? '#7AD098' : '#474E54'}
        fillOpacity={fill ? 1 : '0.25'}
      />
    </svg>
  );
}

function CurrentIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7" fill="#7AD098" stroke="#F6F6F6" strokeWidth="2" />
    </svg>
  );
}

function UpcomingIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#474E54" fillOpacity="0.25" />
    </svg>
  );
}

function CompletedIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#7AD098" />
      <g clipPath="url(#clip0_872_5404)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4418 2.51585C9.26 1.98926 7.93959 1.8588 6.67755 2.14394C5.41551 2.42908 4.27945 3.11455 3.43881 4.0981C2.59816 5.08165 2.09798 6.31059 2.01284 7.60164C1.92771 8.89269 2.2622 10.1767 2.96641 11.2621C3.67063 12.3475 4.70685 13.1762 5.92052 13.6246C7.13419 14.073 8.4603 14.117 9.70105 13.7502C10.9418 13.3833 12.0307 12.6252 12.8054 11.589C13.5801 10.5527 13.9991 9.29371 13.9998 7.99985V7.3869C13.9998 7.01871 14.2983 6.72024 14.6665 6.72024C15.0347 6.72024 15.3332 7.01871 15.3332 7.3869V8.00024C15.3323 9.58161 14.8202 11.1207 13.8733 12.3873C12.9265 13.6539 11.5956 14.5804 10.0791 15.0288C8.56262 15.4772 6.94183 15.4233 5.45845 14.8753C3.97507 14.3273 2.70858 13.3144 1.84787 11.9878C0.987166 10.6612 0.578351 9.09186 0.6824 7.51391C0.78645 5.93596 1.39779 4.43392 2.42524 3.2318C3.4527 2.02968 4.84121 1.1919 6.38371 0.84339C7.92621 0.494884 9.54003 0.65433 10.9845 1.29795C11.3208 1.4478 11.472 1.84192 11.3221 2.17824C11.1723 2.51455 10.7782 2.66571 10.4418 2.51585Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.138 2.19503C15.3985 2.45525 15.3987 2.87736 15.1385 3.13784L8.4718 9.81117C8.3468 9.9363 8.1772 10.0066 8.00033 10.0067C7.82346 10.0067 7.65382 9.93647 7.52876 9.8114L5.52876 7.8114C5.26841 7.55106 5.26841 7.12895 5.52876 6.8686C5.78911 6.60825 6.21122 6.60825 6.47157 6.8686L7.99993 8.39696L14.1952 2.1955C14.4554 1.93502 14.8775 1.93481 15.138 2.19503Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_872_5404">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function Progress({ step }: { step: number }) {
  return (
    <div className={styles.signupProgress}>
      {step >= 1 ? step === 1 ? <CurrentIcon /> : <CompletedIcon /> : <UpcomingIcon />}
      <LineIcon fill={step >= 2} />
      {step >= 2 ? step === 2 ? <CurrentIcon /> : <CompletedIcon /> : <UpcomingIcon />}
      <LineIcon fill={step >= 3} />
      {step >= 3 ? step === 3 ? <CurrentIcon /> : <CompletedIcon /> : <UpcomingIcon />}
    </div>
  );
}

export default Progress;
